import { reactive, ref } from 'vue';
export function useUsersPagination() {
    const id = ref('settings-users-list');
    const pagination = reactive({ count: 0, limit: 10, page: 1 });
    function resetPagination() {
        const FIRST_PAGE = 1;
        pagination.page = FIRST_PAGE;
    }
    return {
        id,
        pagination,
        resetPagination,
    };
}
